<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-overflow
    min-width="290"
    :disabled="readonly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formatDate(value)"
        append-icon="mdi-calendar"
        readonly
        placeholder="No date selected"
        v-bind="{ ...attrs, ...$attrs, label }"
        v-on="on"
      ></v-text-field>
    </template>
    <v-tabs :value="0" centered fixed-tabs>
      <v-tab><v-icon>mdi-calendar</v-icon></v-tab>
      <v-tab><v-icon>mdi-clock</v-icon></v-tab>
      <v-tab-item>
        <v-date-picker
          ref="picker"
          :value="dateValue"
          :min="min"
          :max="max"
          :event-color="eventColor"
          :events="events"
          scrollable
          :allowed-dates="$attrs['allowed-dates']"
          @input="onDateInput"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="$refs.menu.save(date)"> Accept </v-btn>
        </v-date-picker>
      </v-tab-item>
      <v-tab-item>
        <v-time-picker
          :value="time"
          scrollable
          format="24hr"
          :allowed-minutes="(v) => v % 5 === 0"
          @input="onTimeInput"
        />
        <div class="px-4">
          <v-text-field :value="time" @input="onTimeInput" />
        </div>
        <v-spacer></v-spacer>
        <div class="pb-2 pr-2 d-flex justify-end">
          <v-btn text color="primary" @click="$refs.menu.save(date)"> Accept </v-btn>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-menu>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  props: {
    value: String,
    year: Boolean,
    min: {
      type: String,
      required: false,
      default: undefined,
    },
    max: {
      type: String,
      required: false,
      default: undefined,
    },
    "event-color": {
      type: String,
      required: false,
      default: undefined,
    },
    events: {
      type: [Array, Function],
      required: false,
      default: undefined,
    },
    readonly: Boolean,
    label: String,
  },
  data() {
    return {
      date: new Date().toISOString().split("T")[0],
      time: "00:00",
      menu: false,
    };
  },
  computed: {
    ...mapState(["profile"]),
    dateValue() {
      return moment(this.value || new Date())
        .toISOString()
        .substring(0, 10);
    },
  },
  watch: {
    menu(val) {
      if (this.year) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
      }
    },
    value(value) {
      if (!value) {
        return;
      }
      const datetime = moment(value);
      this.date = datetime.format("YYYY-MM-DD");
      this.time = datetime.format("HH:mm");
    },
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return "";
      }
      moment.locale(this.profile.language);
      return moment(date).format("MMM DD YYYY hh:mm a");
    },
    onDateInput(value) {
      this.$emit("input", moment(value + " " + this.time).toISOString());
    },
    onTimeInput(value) {
      this.$emit("input", moment(this.date + " " + value).toISOString());
    },
  },
};
</script>
